type SubjectMap = {
  [key: string]: {
    [key: number]: string
  };
};

type Theme = {
  colors: {
    subjects: SubjectMap
  }
}

interface propTypes {
  color: number,
  subject: string,
  theme: Theme
}

const getSubjectsType = ({
  color,
  subject,
  theme,
}: propTypes) => {
  const subjectMap: SubjectMap = theme.colors.subjects;

  if (subjectMap[subject]) {
    const background = subjectMap[subject][color];

    return `
      ${background};
    `;
  }
};

export default getSubjectsType;
